import { createApp } from "./main";
import { startClient } from "@/entryClientTemplate";

const context = {
    nameSite: "zavtra",
};

startClient(createApp(context));
